// axios
import axios from '@/common/axios.config'
import { baseApi } from '@/config'

let userApi = ''
if(window.location.href.includes('hk')){
  userApi = '//cloud.api.cocorobo.hk'
}else if(window.location.href.includes('com')){
  userApi = '//cloud.api.cocorobo.com'
}else {
  userApi = '//beta.api.cocorobo.cn'
}
// userApi = '//beta.api.cocorobo.cn'

// 用户信息 post 方法
export function eduGet() {
	return axios.get(`${userApi}/api/getcookieuserid`);
}
// 获取组织
export function GetSuffix(data) {
  return axios.post(`https://api.edu.cocorobo.cn/edu/admin/selectorganize`, [data])
}

export function eduLogout() {
  return axios.post(`${userApi}/api/logout`)
}
export function eduGetUserinfo(rk) {
  return axios.get(`https://api.edu.cocorobo.cn/edu/admin/userinfo/userinfoById/${rk}`)
}

// 退出登录
export function loginOut(data) {
  return axios.post(`${userApi}/api/logout`,data)
}

export function getUser(data) {
  return axios.get(`${baseApi}selectUser2`, data)
}
export function getCourseGroup(data) {
  return axios.get(`${baseApi}getCourseGroup`, data)
}

export function selectliyuanByIc2SZ (data) {
  return axios.get(`${baseApi}selectliyuanByIc2SZ`, data)
}
export function updatePassword(data) {
  return axios.post(`${baseApi}updatePassword`, [data])
}

export function addrrole(data) {
  return axios.post(`${baseApi}teacherRegistration`, [data])
}


export function addUser(data) {
  return axios.post(`${baseApi}batchRegistrationUser`, [data])
}

export function addOp(data) {
  return axios.post(`${baseApi}addCourseBehavior`, [data])
}

// PPT 教师数据看板：教学数据全景
export function getPPTDataBoard_all(data) {
  return axios.get(`${baseApi}getPPTDataBoard_all`, data)
}


// // 登录
// export function login(data) {
//   return request({
//     url: api.Login,
//     method: 'post',
//     data
//   })
// }

// // 用户信息 post 方法
// export function getUserInfo(data) {
//   return request({
//     url: api.UserInfo,
//     method: 'post',
//     data,
//     hideloading: true
//   })
// }

// // 用户名称 get 方法
// export function getUserName(params) {
//   return request({
//     url: api.UserName,
//     method: 'get',
//     params,
//     hideloading: true
//   })
// }
